export default __webpack_public_path__ + "static/media/header_logo_2.ffa4aac5.png";